import '../../../styles/Pagination.css';
import { PaginationProps } from './Pagination.types';

export default ({ currentPage, setCurrentPage, numberOfPages }: PaginationProps) => {
  const Content = ({ currentPage, setCurrentPage, numberOfPages }: PaginationProps) => {
    if (numberOfPages > 0) {
      if (numberOfPages < 6) {
        return (
          <>
            {[...Array(numberOfPages)].map((_, index) => (
              <div
                key={index}
                data-testid='pagination-item'
                className={`pagination-item ${
                  index + 1 === currentPage ? ' pagination-item--active' : ''
                }`}
                onClick={() => setCurrentPage(index + 1)}>
                {index + 1}
              </div>
            ))}
          </>
        );
      } else {
        if (currentPage < 4) {
          return (
            <>
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  data-testid='pagination-item'
                  className={`pagination-item ${
                    index + 1 === currentPage ? ' pagination-item--active' : ''
                  }`}
                  onClick={() => setCurrentPage(index + 1)}>
                  {index + 1}
                </div>
              ))}
              <div data-testid='pagination-item' className={`pagination-item pagination-item--not-clickable`}>...</div>
              <div data-testid='pagination-item' className={`pagination-item`} onClick={() => setCurrentPage(numberOfPages)}>
                {numberOfPages}
              </div>
            </>
          );
        } else if (currentPage === 4) {
          return (
            <>
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  data-testid='pagination-item'
                  className={`pagination-item`}
                  onClick={() => setCurrentPage(index + 1)}>
                  {index + 1}
                </div>
              ))}
              <div data-testid='pagination-item' className={`pagination-item pagination-item--active`}>{currentPage}</div>
              <div data-testid='pagination-item' className={`pagination-item pagination-item--not-clickable`}>...</div>
              <div data-testid='pagination-item' className={`pagination-item`} onClick={() => setCurrentPage(numberOfPages)}>
                {numberOfPages}
              </div>
            </>
          );
        } else if (currentPage === numberOfPages - 1) {
          return (
            <>
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  data-testid='pagination-item'
                  className={`pagination-item`}
                  onClick={() => setCurrentPage(index + 1)}>
                  {index + 1}
                </div>
              ))}
              <div data-testid='pagination-item' className={`pagination-item pagination-item--not-clickable`}>...</div>
              <div data-testid='pagination-item' className={`pagination-item pagination-item--active`}>{currentPage}</div>
              <div data-testid='pagination-item' className={`pagination-item`} onClick={() => setCurrentPage(numberOfPages)}>
                {numberOfPages}
              </div>
            </>
          );
        } else if (currentPage === numberOfPages) {
          return (
            <>
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  data-testid='pagination-item'
                  className={`pagination-item`}
                  onClick={() => setCurrentPage(index + 1)}>
                  {index + 1}
                </div>
              ))}
              <div className={`pagination-item pagination-item--not-clickable`}>...</div>
              <div
                className={`pagination-item pagination-item--active`}
                onClick={() => setCurrentPage(numberOfPages)}>
                {numberOfPages}
              </div>
            </>
          );
        } else {
          return (
            <>
              {[...Array(3)].map((_, index) => (
                <div
                  key={index}
                  data-testid='pagination-item'
                  className={`pagination-item`}
                  onClick={() => setCurrentPage(index + 1)}>
                  {index + 1}
                </div>
              ))}
              <div data-testid='pagination-item' className={`pagination-item pagination-item--not-clickable`}>...</div>
              <div data-testid='pagination-item' className={`pagination-item pagination-item--active`}>{currentPage}</div>
              <div data-testid='pagination-item' className={`pagination-item pagination-item--not-clickable`}>...</div>
              <div data-testid='pagination-item' className={`pagination-item`} onClick={() => setCurrentPage(numberOfPages)}>
                {numberOfPages}
              </div>
            </>
          );
        }
      }
    } else {
      return null;
    }
  };
  return (
    <div className="pagination" data-testid='pagination' {...(numberOfPages === 1 && { style: { display: 'none' } })}>
      {numberOfPages > 0 && (
        <div
          className={`pagination-item${currentPage <= 1 ? ' pagination-item--not-clickable' : ''}`}
          {...(currentPage > 1 && {
            onClick: () => setCurrentPage(currentPage - 1),
          })}>
          Préc.
        </div>
      )}
      <Content {...{ currentPage, setCurrentPage, numberOfPages }} />
      {numberOfPages > 0 && (
        <div
          className={`pagination-item${
            numberOfPages === currentPage ? ' pagination-item--not-clickable' : ''
          }`}
          {...(currentPage < numberOfPages && {
            onClick: () => setCurrentPage(currentPage + 1),
          })}>
          Suiv.
        </div>
      )}
    </div>
  );
};
